<div class="align-center mt-3">Once you remove this record, it is gone for good</div>
<div class="mt-3 mb-2 flex-center">
    <button mat-flat-button color="warn" (click)="closeDialog()"> Cancel</button> &nbsp; &nbsp;
    <button mat-flat-button color="primary" (click)="delete()">Discard</button>
</div>